export default [
	{  // 商家管理
		path: 'stationed_user_list',
		name: 'm_srm_stationed_user',
		component: () => import('@/pages/srm/stationed_user_list')
	}, {  // 商家权限角色列表
		path: 'stationed_auth_list',
		name: 'm_srm_auth',
		component: () => import('@/pages/srm/stationed_auth_list')
	}, {  // 新建商家权限角色
		path: 'stationed_auth_add',
		name: 'stationed_auth_add',
		meta: {
			title: '新建商家角色'
		},
		component: () => import('@/pages/srm/stationed_auth_add')
	}, {  // 编辑商家权限角色
		path: 'stationed_auth_edit/:id',
		name: 'stationed_auth_edit',
		meta: {
			title: '编辑商家角色'
		},
		props: route => route.params,
		component: () => import('@/pages/srm/stationed_auth_edit')
	}, {  // 商家主营类目
		path: 'main_categories',
		name: 'm_main_categories',
		component: () => import('@/pages/srm/main_categories')
	}, {  // 经营模式
		path: 'management_model',
		name: 'm_management_model',
		component: () => import('@/pages/srm/management_model')
	}, {  // 商家入驻申请
		path: 'stationed_onboarding_list',
		name: 'm_srm_stationed_onboarding',
		component: () => import('@/pages/srm/stationed_onboarding_list')
	}
];